import { render, staticRenderFns } from "./UploadDragger.vue?vue&type=template&id=4c5c0459&"
import script from "./UploadDragger.vue?vue&type=script&lang=js&"
export * from "./UploadDragger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports